<ul class="productDetailsInfobox">
  <li class="productDetailsInfobox__framesun">{{'productDetails.deliveryTime.frame&sun' | translate}}
    <div class="infoTooltip" (click)="tooltipActive = !tooltipActive" *ngIf="type === productType.SUNGLASSES" [ngClass]="{'infoTooltip-active': tooltipActive}">
      <i class="infoTooltip_icon"></i>
      <div class="infoTooltip_desc">
        <b [innerHTML]="'productDetails.deliveryTime.frameTooltip' | translate"></b>
      </div>
    </div>
  </li>
  <li *ngIf="site === sites.VISIONEXPRESS" class="productDetailsInfobox__visioncare">
    <a [href]="visioncareURL" target="_blank">{{'productDetails.visioncare' | translate}}</a>
  </li>
  <li class="productDetailsInfobox --goto" class="productDetailsInfobox__availibity"><button (click)="goto(availability)">{{'productDetails.posAvailibity' | translate}}</button></li>
  <li *ngFor="let info of shoppingBenefits"><figure *ngIf="info.icon"><img [src]="info.icon" alt=""></figure>{{info.text}}</li>
</ul>
